import { useCallback, useEffect, useState } from "react";

import {
  addTranslationData,
  useTranslation,
} from "@mywheels/common/lib/translation";

import { dayjs } from "../util/dayjs";

const MOVE_END = dayjs("2021-10-01 00:00");

const DAY = 1000 * 60 * 60 * 24;
const HR = 1000 * 60 * 60;
const MIN = 1000 * 60;
const SEC = 1000;

addTranslationData({
  en: {
    "{d}d {h}u {m}m {s}s": "{d}d {h}h {m}m {s}s",
    "{d}d {h}u {m}m {s}s te gaan!": "{d}d {h}h {m}m {s}s to go!",
  },
});

export function useMoveCountdown(togo = true) {
  const { t } = useTranslation();

  const computeCountdown = useCallback(() => {
    const msFromNow = Math.max(0, +MOVE_END - Date.now());
    const d = Math.floor(msFromNow / DAY);
    const h = Math.floor((msFromNow - d * DAY) / HR);
    const m = Math.floor((msFromNow - d * DAY - h * HR) / MIN);
    const s = Math.floor((msFromNow - d * DAY - h * HR - m * MIN) / SEC);
    return t(togo ? "{d}d {h}u {m}m {s}s te gaan!" : "{d}d {h}u {m}m {s}s", {
      d,
      h,
      m,
      s,
    });
  }, [t, togo]);

  const [countdown, setCountdown] = useState(computeCountdown);

  useEffect(() => {
    setCountdown(computeCountdown());

    const t = setInterval(() => {
      setCountdown(computeCountdown());
    }, 1000);

    return () => {
      clearInterval(t);
    };
  }, [t, computeCountdown]);

  return countdown;
}
